export const texts = {
    label: {
        loading: 'Bitte warten'
    }
};

//# sourceMappingURL=box-cta.texts.js.map